<app-dialog [visible]="visible" [showCloseButton]="false" [fullscreenOnMobile]="true" class="max-w-[32rem]"
    (closed)="onHide()">
    <ng-template #bodyTemplate>
        <form [formGroup]="phoneForm" class="flex flex-col gap-4 overflow-y-auto">
            <div class="flex flex-col">
                <div class="flex items-center gap-x-2">
                    <app-icon [type]="'info'" [size]="'sm'" [source]="'lucide'" />
                    <p class="text-md font-semibold">Phone number missing in profile</p>
                </div>
                <p class="text-md ml-6">To contact sales, a phone number is required. Please enter your phone number.
                </p>
            </div>
            <div class="flex flex-col gap-2">
                <p class="text-md text-gray-700">Phone number<span class="text-red-500"> *</span></p>
                <app-phone-input formControlName="phoneNumber" (phoneNumberChange)="onPhoneNumberChange($event)" appendTo="body" />
                @if (phoneForm.get('phoneNumber')?.invalid && phoneForm.get('phoneNumber')?.touched) {
                    <p class="text-xs text-red-500 mt-0.5">Please enter a valid phone number</p>
                }
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex items-center justify-end gap-2">
            <app-button (clicked)="closeDialog()" [label]="'Cancel' | textCase" [size]="'default'"
                [variant]="'outlined'" [severity]="'contrast'" />
            <app-button (clicked)="submitPhoneNumber()" [label]="'Submit' | textCase" [size]="'default'"
                [variant]="'filled'" [severity]="'primary'" />
        </div>
    </ng-template>
</app-dialog>
